import { TurnoPrevioAcceso } from '../Turnero/TurnoPrevioAcceso';

export const TurnoPrevio = () => {
  return <TurnoPrevioAcceso />;
};
